import {
  Component,
  Input,
  ChangeDetectorRef,
  AfterContentChecked,
  Output,
  EventEmitter,
  ViewEncapsulation,
} from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-auto-complete-text-field',
  templateUrl: './auto-complete-text-field.component.html',
  styleUrls: ['./auto-complete-text-field.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AutoCompleteTextFieldComponent implements AfterContentChecked {
  @Input() searchableSelector = 'name';

  @Input() searchableData: any;

  @Input() label: string;

  @Input() name: string;

  @Input() error = false;

  @Input() control: FormControl;

  @Input() submitted = false;

  @Input() disabled = false;

  @Output() selectOption = new EventEmitter();

  constructor(private readonly changeDetectorRef: ChangeDetectorRef) {}

  ngAfterContentChecked(): void {
    if (this.control) {
      this.changeDetectorRef.detectChanges();
    }
  }

  get errors(): boolean {
    if (this.control) {
      return this.control.invalid;
    }
  }

  selectEvent(item) {
    this.selectOption.emit(item);
  }
}
